import React, { useEffect, useRef, useState } from "react";
import { Alert, Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { IGreyFleetDriverRequestModel,IGreyFleetDriverResponseModel,getGreyFleetDriver, isUserAuthenticated, saveGreyFleetDriver } from "./WorkerService";
import moment from "moment";
import trashcan from "../assets/images/opened-trash-can.png";
// import { useUserContext } from "./UserContext";
// import { useNavigate } from "react-router-dom";
import ImageCapture from "./ImageCapture";
import Header from "./Header";

const DataCapture: React.FC = () => {
    // const navigate = useNavigate();
    // const usercontext = useUserContext();

    const [formData, setFormData] = useState<IGreyFleetDriverRequestModel | undefined>(undefined);
    const [existingData, setExistingData] = useState<IGreyFleetDriverResponseModel | undefined>(undefined);
    const [isTakePhoto, setIsTakePhoto] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [errors, setErrors] = useState<string[]>([]);
    const [zoomImage, setZoomImage] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);

    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const checkIfloggedIn = async () => {
            if(!await isUserAuthenticated()){
                window.location.href = "/login";
            }
        }
        checkIfloggedIn();
    }, [])

    try {
        useEffect(() => {
            const result = getGreyFleetDriver();
            result.then(data => {
                if(data){
                    data.insurance_policy_start_date = dateForPicker(data.insurance_policy_start_date);
                    data.insurance_policy_end_date = dateForPicker(data.insurance_policy_end_date);
                    data.breakdown_policy_start_date = dateForPicker(data.breakdown_policy_start_date);
                    data.breakdown_policy_end_date = dateForPicker(data.breakdown_policy_end_date);
                    data.mot_renewal_date = dateForPicker(data.mot_renewal_date);
                    data.road_tax_renewal_date = dateForPicker(data.road_tax_renewal_date);
                }
    
                console.log("initial formData -> ", data);
                setFormData(data);
                setExistingData(data);
            }
        )}, [])
    } catch (error) {
        console.log("Error in getGreyFleetDriver() -> ", error);
    }
  
    const handleSubmit = async (event: any) => {
        event.preventDefault();

        setIsSubmitting(true);
        console.log("formData to save -> ", formData);

        setIsValidated(true);
        scrollToTop();

        if(!validateInputs()){
            displayErrorAlert();
            setIsSubmitting(false);
            return;
        }

        const method = existingData ? "PATCH" : "POST";
        try {
            const x = await saveGreyFleetDriver(method, formData);
            console.log("data returned from saving -> ", x);
            setIsValidated(false);
            displaySuccessAlert();
        } catch (error: any) {
            setIsValidated(false);
            console.log(error.message);
            setErrors(prev => [...prev, error.message]);
            if(error.message.indexOf("401") >= 0) {
                window.location.href = "/login";
            }
            displayErrorAlert();
        }
        setIsSubmitting(false);
    };

    const handleOnChange = (e: any) => {
        const { name, value, checked } = e.target;
      
        if(name.startsWith("insured_for_business")){
            if(name === "insured_for_business_yes"){
                setFormData({ ...formData, "insured_for_business": checked });
            }
            if(name === "insured_for_business_no"){
                setFormData({ ...formData, "insured_for_business": !checked });
            }
        }
        else
        {
            setFormData({ ...formData, [name]: value });
        }
    };

    const findAvailableSlot = () => {
        let index;
        let found = false;
        for (index = 1; index <= 5; index++) {
            if(!formData?.[`photo_${index}_name`] && !formData?.[`photo_${index}_url`]){
                found = true;
                break;
             } 
        }

        return found ? index : 1;
    }

    const savePhoto = (base64str: string) => {
        const vehReg = formData?.vehicle_registration;
        let name="";
        let data="";

        let index = findAvailableSlot();
        name = `photo_${index}_name`;
        data = `photo_${index}_data`;

        setFormData({ ...formData, 
            [name]: `${vehReg}_${index}.png`, 
            [data]: base64str });
    };

    const saveDocument = (fileName: string, base64str: string) => {
        const vehReg = formData?.vehicle_registration;
        const extn = fileName.split('.');
        const extn1 = "." + extn[extn.length - 1];
        let name="";
        let data="";

        let index = findAvailableSlot();
        name = `photo_${index}_name`;
        data = `photo_${index}_data`;

        setFormData({ ...formData, 
            [name] : vehReg! + extn1,
            [data] : base64str 
        });
    };

    const dateForPicker = (dateString?: string) => {
        const d = moment(new Date(dateString!)).format('yyyy-MM-DD');
        if(d <= "1970-01-01"){
            return "";
        }
        return d;
    };

    const displaySuccessAlert = () => {
        setShowSuccessAlert(true);
        setTimeout(function () {
            setShowSuccessAlert(false);
        }, 5000);
    };

    const displayErrorAlert = () => {
        setShowErrorAlert(true);
        setTimeout(function () {
            setShowErrorAlert(false);
        }, 5000);
    };

    const validateInputs = () => {

        setErrors([]);

        if(!formData?.vehicle_registration
            || !formData?.insurance_provider
            || !formData?.insurance_policy_start_date
            || !formData?.insurance_policy_end_date) {
            return false;
        }

        let hasPhoto = false;
        for (let index = 1; index <= 5; index++) {
            if(formData?.[`photo_${index}_url`]?.length > 0 || formData?.[`photo_${index}_name`]?.length > 0 ){
                hasPhoto = true;
                break;
            }
        }

        if(!hasPhoto){
            setErrors(prev => [...prev, "No insurance document photo"]);
            return false;
        }

        if(!isDateValid(formData?.insurance_policy_start_date)){
            return false;
        }

        if(!isDateValid(formData?.insurance_policy_end_date)){
            return false;
        }

        return true;
    };

    const isDateValid = (d: string) => {
        let date = moment(d);
        return date.isValid();
    };

    const scrollToTop = () => {
        if(divRef.current){
            divRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
    };

    const convertFileToBase64 = (file: File): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result as string;
                resolve(base64String.split(',')[1]); // Extract the base64 string without the data URL prefix
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const handleFileInput =async (event: any) => {
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        const selectedFile = fileInput.files![0];
        if (selectedFile) {
            try {
                const base64String = await convertFileToBase64(selectedFile);
                console.log(base64String);
                saveDocument(selectedFile.name, base64String);
            } catch (error) {
                console.error('Error converting file to base64:', error);
            }
        }
    };

    const removePhoto = (index: string) => {
        setFormData({ ...formData, [`photo_${index}_name`]: "", [`photo_${index}_data`]: "", [`photo_${index}_url`]: ""});
        // setExistingData({ ...existingData, [`photo_${index}_url`]: "" });
    };

    const getNameFromUrl = (url: string) => {
        let x = url.indexOf("?");
        let result = url.substring(0, x);
        let y = result.lastIndexOf("/");
        result = url.substring(y + 1, x);
        return result;
    }

    const displayPhoto = (index: string) => {
        const data: string = `photo_${index}_data`;
        const name = `photo_${index}_name`;
        const url = `photo_${index}_url`;

        return (
            (formData?.[data] || formData?.[url]) &&
                <div>
                    <img alt={formData?.[name] ? formData?.[name] : getNameFromUrl(formData?.[url])}
                        src={formData?.[name] 
                                ? `data:image/jpeg;base64,${formData?.[data]}`
                                : formData?.[url]}
                        className="img-thumbnail" width={zoomImage ? "300" : "75"}
                        onClick={() => setZoomImage(() => !zoomImage)}
                        style={{cursor:"pointer", marginBottom:"4px"}}
                    />
                    <img src={trashcan} alt="" onClick={() => removePhoto(index)} height="25px" style={{backgroundColor: "transparent", cursor:"pointer", marginLeft:"10px"}}></img>
                </div>
        )
    };

    return (
        <div>
            {!isTakePhoto &&
                <div className="data-capture-container">
                    <Header title="DATA CAPTURE"/>
                    <div className="data-capture" ref={divRef}>
                        {showSuccessAlert && 
                            <Alert variant="success" dismissible >Saved successfully.</Alert>      
                        }
                        {showErrorAlert && 
                            <Alert variant="danger" dismissible >Saving info failed. Check for errors.</Alert>      
                        }
                        {showErrorAlert && errors.length > 0 && 
                            <Alert variant="danger" dismissible >{errors[0]}</Alert>      
                        }

                        <Form noValidate validated={isValidated}>
                            <Form.Group controlId="vehicle_Registration">
                                <Form.Label>Vehicle Registration Number</Form.Label>
                                <Form.Control type="text" name="vehicle_registration"
                                    value={formData?.vehicle_registration}
                                    onChange={handleOnChange}
                                    required 
                                />
                            </Form.Group>

                            <Form.Group controlId="insured_for_business">
                                <Form.Label>Insured for Business Use</Form.Label>
                                <div className="d-flex flex-row">
                                    <Form.Check 
                                        className="me-5"
                                        label="Yes"
                                        name="insured_for_business_yes"
                                        value="yes"
                                        type="checkbox"
                                        onChange={handleOnChange}
                                        checked={formData?.insured_for_business === true}
                                    />
                                    <Form.Check 
                                        label="No"
                                        value="no"
                                        name="insured_for_business_no"
                                        type="checkbox"
                                        onChange={handleOnChange}
                                        checked={formData?.insured_for_business === false}
                                    />
                                </div>
                            </Form.Group>

                            <Form.Group controlId="insurance_provider">
                                <Form.Label>Insurance Provider</Form.Label>
                                <Form.Control type="text" name="insurance_provider" required 
                                    value={formData?.insurance_provider}
                                    onChange={handleOnChange} />
                            </Form.Group>

                            <Form.Group controlId="insurance_policy_start_date">
                                <Form.Label>Insurance Policy Start Date</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="insurance_policy_start_date"                             
                                    value={formData?.insurance_policy_start_date}
                                    required
                                    onChange={handleOnChange} />
                            </Form.Group>

                            <Form.Group controlId="insurance_policy_end_date">
                                <Form.Label>Insurance Policy End Date</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="insurance_policy_end_date" 
                                    value={formData?.insurance_policy_end_date}
                                    required
                                    onChange={handleOnChange} />
                            </Form.Group>

                            <Form.Label>Insurance Policy Document</Form.Label>
                            <div className="mt-1">
                                {displayPhoto("1")}
                                {displayPhoto("2")}
                                {displayPhoto("3")}
                                {displayPhoto("4")}
                                {displayPhoto("5")}
                            </div>

                            <Form.Group controlId="fileInput" className="mt-2 mb-3">
                                <Form.Label>Upload or Take a Photo of Insurance Document</Form.Label><br />
                                <div className="mb-2">
                                    <Form.Control type="file" size="sm" onChange={handleFileInput} />
                                </div>
                                <div className="text-center">
                                    <Button type="button" variant="success" style={{width:"50%"}} onClick={() => setIsTakePhoto(!isTakePhoto)}>
                                        Take a Photo of Document
                                    </Button>
                                </div>
                            </Form.Group>

                            <Form.Group controlId="breakdown_provider">
                                <Form.Label>Breakdown Provider</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="breakdown_provider" 
                                    value={formData?.breakdown_provider}
                                    onChange={handleOnChange} />
                            </Form.Group>

                            <Form.Group controlId="breakdown_policy_start_date">
                                <Form.Label>Breakdown Policy Start Date</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="breakdown_policy_start_date" 
                                    value={formData?.breakdown_policy_start_date}
                                    onChange={handleOnChange} />
                            </Form.Group>

                            <Form.Group controlId="breakdown_policy_end_date">
                                <Form.Label>Breakdown Policy End Date</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="breakdown_policy_end_date" 
                                    value={formData?.breakdown_policy_end_date}
                                    onChange={handleOnChange} />
                            </Form.Group>

                            <Form.Group controlId="road_fund_renewal_date">
                                <Form.Label style={{fontSize: ".8rem"}}>The following fields will be looked up once your vehicle registration has been entered.</Form.Label>
                            </Form.Group>
                            
                            <Form.Group controlId="road_fund_renewal_date">
                                <Form.Label>Road Fund Licence (Tax) End Date</Form.Label>
                                <Form.Control type="date" readOnly name="road_fund_renewal_date" value={existingData?.road_tax_renewal_date} />
                            </Form.Group>

                            <Form.Group controlId="mot_renewal_date">
                                <Form.Label>MOT Expiry Date</Form.Label>
                                <Form.Control type="date" readOnly name="mot_renewal_date" value={existingData?.mot_renewal_date} />
                            </Form.Group>
                        </Form>
                    </div>
                    <div className="footer">
                        <Button variant="success" type="submit" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? "Saving info..." : "Submit"}</Button>
                    </div>
                </div>
            }

            {isTakePhoto &&
                <div>
                    <ImageCapture onClose={() => {setIsTakePhoto(false)}} savePhoto={savePhoto}/>
                </div>
            }
        </div>
    );
}

export default DataCapture;